import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Banner } from '@optimus-web/core';

interface CreatePreviewBannerProps {
    formType: 'createForm';
    areExceptionFormValuesBlank: boolean;
    isCreatingRestrictions: boolean;
    isDeletingRestrictions: boolean;
    isDeletingEmptyExceptionRestrictions: boolean;
    isKeepingEmptyExceptionRestrictions: boolean;
    isKeepingRestrictions: boolean;
    containsInvalidRestrictions: boolean;
}

interface PreviewBannerProps {
    formType: 'editForm' | 'deleteForm';
    isCreatingRestrictions: boolean;
    isDeletingRestrictions: boolean;
    isDeletingEmptyExceptionRestrictions: boolean;
    containsInvalidRestrictions: boolean;
}

export const PreviewBanner = ({
    isCreatingRestrictions,
    isDeletingRestrictions,
    isDeletingEmptyExceptionRestrictions,
    containsInvalidRestrictions,
    ...props
}: PreviewBannerProps | CreatePreviewBannerProps) => {
    if (containsInvalidRestrictions) {
        return (
            <Banner
                primaryText={<LocalizedText textKey={TextKey.RestrictionConflictPreviewBannerTitle} />}
                secondaryText={<LocalizedText textKey={TextKey.RestrictionConflictPreviewBannerDescription} />}
                variant="warning"
            />
        );
    }
    if (props.formType === 'createForm' && props.isKeepingRestrictions) {
        if (props.areExceptionFormValuesBlank && !props.isKeepingEmptyExceptionRestrictions) {
            return (
                <Banner
                    primaryText={<LocalizedText textKey={TextKey.PreviewEmptyExceptionsTakePriorityBannerTitle} />}
                    variant="warning"
                />
            );
        }

        if (!props.areExceptionFormValuesBlank && props.isKeepingEmptyExceptionRestrictions) {
            return (
                <Banner
                    primaryText={<LocalizedText textKey={TextKey.PreviewEmptyExceptionsBannerTitle} />}
                    secondaryText={<LocalizedText textKey={TextKey.PreviewEmptyExceptionsBannerDescription} />}
                    variant="warning"
                />
            );
        }

        return (
            <Banner
                primaryText={<LocalizedText textKey={TextKey.UnchangedSharedConditionsBannerDescription} />}
                variant="warning"
            />
        );
    }

    if (props.formType === 'createForm' && isDeletingEmptyExceptionRestrictions) {
        return (
            <Banner
                primaryText={<LocalizedText textKey={TextKey.DeleteEmptyExceptionsRestrictionBannerDescription} />}
                variant="error"
            />
        );
    }
    if (props.formType === 'createForm' && isCreatingRestrictions && isDeletingRestrictions) {
        return (
            <Banner
                primaryText={<LocalizedText textKey={TextKey.RestrictionReplacePreviewBannerMessage} />}
                variant="warning"
            />
        );
    }
    if (props.formType === 'createForm' && isCreatingRestrictions) {
        return (
            <Banner
                primaryText={<LocalizedText textKey={TextKey.RestrictionCreatePreviewBannerMessage} />}
                variant="info"
            />
        );
    }
    if (props.formType === 'editForm') {
        return (
            <Banner
                primaryText={<LocalizedText textKey={TextKey.RestrictionReplacePreviewBannerMessage} />}
                variant="warning"
            />
        );
    }
    if (props.formType === 'deleteForm' && isCreatingRestrictions && isDeletingRestrictions) {
        return (
            <Banner
                primaryText={<LocalizedText textKey={TextKey.RestrictionDeletePreviewReplaceBannerMessage} />}
                variant="error"
            />
        );
    }
    if (props.formType === 'deleteForm' && isDeletingRestrictions) {
        return (
            <Banner
                primaryText={<LocalizedText textKey={TextKey.RestrictionDeletePreviewBannerMessage} />}
                variant="error"
            />
        );
    } else if (props.formType === 'deleteForm') {
        return (
            <Banner
                primaryText={<LocalizedText textKey={TextKey.NoMatchingRestrictions} />}
                secondaryText={<LocalizedText textKey={TextKey.NoMatchingRestrictionsTableMessage} />}
                variant="error"
            />
        );
    }

    return null;
};
